export interface Proposal {
  firstRequestCreatedOn: string;
  source: string;
  requestEndpoint: string;
  entityId?: number;
  entityType?: string;
  sportIds: Array<number>;
  name: string;
  fixtureStartTime: string;
  requestsCount: number;
  seasonId: number;
  seasonName: string;
}

/**
 * The shape returned by the paged ingestion list endpoints that project into a slim
 * model. It deliberately has no requestOriginalValue/requestCuratedValue, so the
 * compiler rejects list code that reaches into the proposal values.
 */
export interface SimplifiedProposalListItem {
  id: number;
  createdOn: string;
  name: string;
  sourceName: string;
  geniusSportId: number;
  geniusSportSportId: number;
  sourcePriority: string;
  status: number | string;
  trackingRequestId: string;
  modifiedOn: string;
  sourceEntityId: string;
  statusDetails?: string;
}

export interface SimplifiedProposal extends SimplifiedProposalListItem {
  requestOriginalValue: any;
  requestCuratedValue: any;
}

interface MetadataProperty {
  name: string;
  value: string;
  isDeleted?: boolean;
}

export interface Competitor extends Entity {
  competitorType: string;
  metadataProperties?: MetadataProperty[];
}

export type FixtureUpdate = Partial<{
  id: number;
  createdOn: string;
  modifiedOn: string;
  updatesCount: number;
  metadataProperties: MetadataProperty[];
  startDate: string;
  name: string;
  season: Entity;
  eventStatusType: string;
  locality: Entity;
  timezone: Entity;
  venue: Entity;
  sport: Entity;
  competition: Entity;
  round: Entity;
  homeCompetitor: Competitor;
  genderType: string;
  competitors: Competitor[];
  fixtureLink: Entity;
  eventType: string;
  matchDay: number;
  attendance: number;
}>;

export enum SimplifiedTrackingStatus {
  Accepted = 0,
  AwaitingMatching = 1,
  MatchedAndProposed = 3,
  ProposedAndApproved = 5,
  Matched = 8,
  FailedToProcess = 9,
  ProposedAndWaitingCuration = 10,
  EnrichingProposal = 12,
  Suspended = 14,
  Ignored = 15,
}
